import styled from 'styled-components';
import SearchIcon from '@mui/icons-material/Search';

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border: 1px solid var(--Light-Azul---light, #4BBFEF);
  background: var(--Dark-Branco, #FFF);
  padding-left: 40px;
  border-radius: 8px;
  padding: 4px 6px;
  margin-right: 6px;
  margin-top: 3px;

  /* #956: o anel de foco fica no contorno do campo */
  &:focus-within {
    outline: 2px solid #222222;
    outline-offset: 2px;
    box-shadow: 0 0 0 2px #FFFFFF;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  &&:focus-visible {
    outline: 0;
    box-shadow: none;
  }
  font-family: Roboto;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-900, #383838);
  ::placeholder {
    color: var(--gray-400, #B8B8B8);
  }
  display:flex;
`;

export const SearchIconButton = styled.button`
  background: none;
  border: none;
  padding: 16px;
  cursor: pointer;
  margin-right: 8px; /* Adicionando margem à direita */
`;
